// import type { Action, Reducer, Effect } from 'umi';
import type { Action, Reducer } from 'umi';
import type { IPayload } from '@gp/types/global';

export interface ICollapseableLogoListState {
  expandLogoList: string[];
}

type IAddExpandLogoListAction = Action<'addExpandLogoList'> & IPayload<string>;
type IClearExpandLogoListAction = Action<'clearExpandLogoList'>;

export interface ICollapseableLogoListModel {
  namespace: string;
  state: ICollapseableLogoListState;
  effects: {};
  reducers: {
    addExpandLogoList: Reducer<ICollapseableLogoListState, IAddExpandLogoListAction>;
    clearExpandLogoList: Reducer<ICollapseableLogoListState, IClearExpandLogoListAction>;
  };
}

export const COLLAPSEABLE_LOGO_LIST_MODEL_NAMESPACE = 'dbg-model-collapseable-logo-list';

const CollapseableLogoListModel: ICollapseableLogoListModel = {
  namespace: COLLAPSEABLE_LOGO_LIST_MODEL_NAMESPACE,
  state: {
    expandLogoList: [],
  },
  effects: {},
  reducers: {
    addExpandLogoList(state, action) {
      const { payload } = action || {};
      if (!payload) return { ...state };
      const currentExpandLogoList = state?.expandLogoList || [];
      if (currentExpandLogoList?.includes(payload)) return { ...state };
      const newExpandLogoList = [...currentExpandLogoList, payload];
      return { ...state, expandLogoList: newExpandLogoList };
    },
    clearExpandLogoList(state) {
      return { ...state, expandLogoList: [] };
    },
  },
};

export default CollapseableLogoListModel;
